import PropTypes from 'prop-types';
import React from 'react';

// import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default class SelectField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: undefined,
      open: false,
    };
  }

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ open: false });
    this.props.onChange(index);
  };

  keyDown = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      this.setState({ open: false });
    }
  };

  render() {
    const { style, name, label, value, children } = this.props;

    return (
      <div>
        <Button
          style={style}
          onClick={this.handleClick}
          name={name}
          label={label}
          value={value}
          id={`${this.props.idPrefix}-button`}
        >
          {name}
          {value}
        </Button>
        <Menu open={this.state.open} anchorEl={this.state.anchorEl} aria-label={label} onKeyDown={this.keyDown}>
          {children.map((key) => (
            <MenuItem
              key={key.value}
              id={`${this.props.idPrefix}-${key.value.toLowerCase()}`}
              selected={key.value === this.props.value}
              onClick={(event) => this.handleMenuItemClick(event, key.value)}
            >
              {key.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }
}

SelectField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.any,
  value: PropTypes.string,
  children: PropTypes.array,
  style: PropTypes.string,

  onChange: PropTypes.func,
  idPrefix: PropTypes.string,
};

SelectField.defaultProps = {
  idPrefix: 'select-field-',
};
